export const REFRESH_TOKENS_MESSAGE = 'refreshTokens';

export const ROUTE_CHANGE_MESSAGE = 'routeChange';
